import styled from "styled-components";

export const OnBoardingModalContainer = styled.div``;
